/*
 * @Author: caiqin.xie
 * @since: 2023-08-24 16:13:13
 * @lastTime: 2023-11-10 16:47:59
 * @LastEditors: caiqin.xie
 * @message: newsroom页
 * @url: www.picoxr.com/cn/newsroom
 */
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import RecommendedNews from './components/RecommendedNews'
import MoreNews from "./components/MoreNews";
import HotTopic from "./components/HotTopic";
import Pagination from "@/components/Pagination";
import request from '@/common/request'
import { useDevice } from '@/hooks'
import { DOMAIN_API, COUNTRY_HREFLANG, COUNTRY_LIST, NEWSTYPE } from '@/common/const'
import { getUrlData } from '@/common/untils'
import { INews } from "@/common/types";
import styles from "./index.module.scss";
const _ = require("lodash");

const Newsroom = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const location = useLocation()
  const query: Record<string, any> = getUrlData(decodeURIComponent(location.search)) // 获取地址栏参数
  const newsList: INews[] = data?.recommendContents || [] // 推荐新闻列表
  const [moreList, setMoreList] = useState<INews[]>(data?.contentPage?.records || []) // 更多新闻
  const [allMoreList, setAllMoreList] = useState<INews[]>(data?.contentPage.records || []) // 全部新闻（pad/mobile)
  const [pageNum, setPageNum] = useState<number>(query.page * 1 || 1) // 当前页码
  const [total, setTotal] =  useState<number>(data?.contentPage?.total * 1 || 0) // 新闻总数
  const [pages, setPages] =  useState<number>(data?.contentPage?.pages * 1 || 1) // 新闻总页数

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/newsroom`} />
      ))
    )
  }

  // 获取更多新闻
  const getMoreList = (pageNum: number) => {
    request.post(`${DOMAIN_API}/o/official/content/getContentPage`, {
      contentTypeId: NEWSTYPE,
      stationCode: ctry,
      page: pageNum,
      rows: 10
    })
    .then(res => {
      const {total, records, pages} = res.data
      setTotal(total * 1)
      setPages(pages * 1)
      setMoreList(records)
      setAllMoreList(allMoreList => _.uniqBy([...allMoreList, ...records], 'id'))
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 分页改变
  const pageChange = (pageNum:number) => {
    setPageNum(pageNum)
    if (device === 'pc') {
      if (pageNum === 1) {
        window.open(`/${ctry}/newsroom`, '_self')
      } else {
        window.open(`/${ctry}/newsroom?page=${pageNum}`, '_self')
      }
    } else {
      getMoreList(pageNum)
    }
  }

  return (
    <div>
      <Helmet>
        <title>{words?.newsroom_seo_title}</title>
        <meta name="description" content={words?.newsroom_seo_description} />
        <meta name="keywords" content={words?.newsroom_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/newsroom`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['news-wrap']}>
        {/* 顶栏 */}
        <HotTopic ctry={ctry} words={words}></HotTopic>

        {/* 内容区 */}
        <div className={styles["content-wrap"]}>
          {/* 推荐新闻列表 */}
          <RecommendedNews
            ctry={ctry}
            words={words}
            newsList={newsList}
            pageNum={pageNum}
            device={device} />
          {/* 更多新闻 */}
          <MoreNews
            className={`${styles['section']} ${styles['more-news']}`}
            titleClassName={styles['section-title']}
            ctry={ctry}
            words={words}
            moreNewsList={device === 'pc' ? moreList : allMoreList} />
            {/* 分页 */}
            <Pagination
              words={words}
              device={device}
              pageNum={pageNum}
              pages={pages}
              pageSize={10}
              total={total}
              pageChange={pageChange} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const decodedUrl = decodeURIComponent(pathName);
    const query = getUrlData(decodedUrl)
    const page = query.page || 1
    request.post(`${DOMAIN_API}/o/official/content/getNewsGather`, {
      stationCode: ctry,
      contentTypeId: NEWSTYPE,
      page: page,
      rows: 10
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

Newsroom.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default Newsroom;
